export default "__VITE_ASSET__hKGUEkb6__"